import styled from '@emotion/styled';
import { ITheme } from '../../../../../../ui';

export const StyledMicroformInputContainer = styled.div<{}, ITheme>`
	background: ${({ theme: { input } }) => input.background};
	border: ${({ theme: { input } }) => input.border};
	height: 40px;
	padding: 0 10px;
	border-radius: 4px;

	> input::placeholder {
		color: ${({ theme: { input } }) => input.placeholder.color};
	}
`;
